// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

// var config = {
//   apiKey: 'AIzaSyCsLdVNQtv_RjsvV73JOVlRoLi16l5XrNU', //AIzaSyAe8pRAGGMUBOplBnnVa0lnrLkxFO1Mkk4
//   authDomain: 'mall91-dc1cf.firebaseapp.com',
//   projectId: 'mall91-dc1cf'
// };



var config = {
    apiKey: "AIzaSyA5rXPhkNWNsfnHboP74oWAaMPzHZWSEi8",
    authDomain: "payboard-b01d3.firebaseapp.com",
    databaseURL: "https://payboard-b01d3.firebaseio.com",
    projectId: "payboard-b01d3",
    storageBucket: "payboard-b01d3.appspot.com"
};

firebase.initializeApp(config);
var database = firebase.database();


Vue.prototype.database = database
Vue.prototype.firebase = firebase

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js